import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { OrderChannel } from "./order_channel.js";
//#region src/order_channel_helper.ts
var order_channel_helper_exports = /* @__PURE__ */ __exportAll({
	isFlash: () => isFlash,
	isKiosk: () => isKiosk,
	isKorMonitored: () => isKorMonitored,
	isOrderAhead: () => isOrderAhead,
	korExcludedOrderChannels: () => korExcludedOrderChannels,
	name: () => name,
	nameCombiningKioskAndFlash: () => nameCombiningKioskAndFlash
});
function name(channel) {
	switch (channel) {
		case "catering": return "Catering";
		case "drive-thru": return "Drive-Thru";
		case "flash": return "Contactless";
		case "kiosk": return "Kiosk";
		case "linebuster": return "Linebuster";
		case "web": return "Web";
	}
}
function nameCombiningKioskAndFlash(channel) {
	switch (channel) {
		case "kiosk": return "Kiosk/Flash";
		case "catering":
		case "drive-thru":
		case "flash":
		case "linebuster":
		case "web": return name(channel);
	}
}
function isOrderAhead(channel) {
	switch (channel) {
		case "catering":
		case "web": return true;
		case "drive-thru":
		case "flash":
		case "kiosk":
		case "linebuster": return false;
	}
}
function isKiosk(channel) {
	switch (channel) {
		case "drive-thru":
		case "linebuster":
		case "kiosk": return true;
		case "catering":
		case "web":
		case "flash": return false;
	}
}
/**
* Whether KOR watches the kiosks at a location on this channel: the kiosk channels, minus
* Linebuster. Linebuster devices are handhelds that staff turn off and carry out of range, so
* their outages are noise, not incidents. The other channels have no kiosks.
*/
function isKorMonitored(channel) {
	switch (channel) {
		case "drive-thru":
		case "kiosk": return true;
		case "catering":
		case "flash":
		case "linebuster":
		case "web": return false;
	}
}
/** For `orderChannel: { $nin: korExcludedOrderChannels }` location filters. */
const korExcludedOrderChannels = Object.values(OrderChannel).filter((channel) => !isKorMonitored(channel));
function isFlash(channel) {
	switch (channel) {
		case "catering":
		case "kiosk":
		case "flash":
		case "web": return true;
		case "drive-thru":
		case "linebuster": return false;
	}
}
//#endregion
export { isFlash, isKiosk, isKorMonitored, isOrderAhead, korExcludedOrderChannels, name, nameCombiningKioskAndFlash, order_channel_helper_exports };

//# sourceMappingURL=order_channel_helper.js.map